<template>
  <div>
    <Header />
    <div class="middle1 flex-wrap" style="margin-top: 14px">
      <div>
        <MyInfo :num111="6" />
      </div>

      <div class="my_right flex-con">
        <div class="order_box">
          <div class="align-start cheng_head11">
            <div class="font-333-20-bold">认证中心</div>
            <el-image
              v-if="status != 0"
              style="width: 30px; height: 30px; margin-left: 15px"
              :src="require('@/assets/rz' + status + '.png')"
              fit="cover"
            ></el-image>
          </div>
          <div style="padding-right: 32px">
            <div class="font-333-16-bold flex-wrap" style="margin-top: 22px">
              <div class="width102 align-end">
                <span class="cor_FA9C22">*</span>姓名:
              </div>
              <input
                type="text"
                name=""
                value=""
                v-model="data.user_js_name"
                placeholder="请输入姓名"
                class="flex-con"
                :readonly="status == 1 || status == 2"
                :class="{ border_none: status == 1 || status == 2 }"
              />
            </div>
            <div class="font-333-16-bold flex-wrap" style="margin-top: 22px">
              <div class="width102 align-end">
                <span class="cor_FA9C22">*</span>身份类型:
              </div>

              <div v-if="status == 1 || status == 2">{{ userSF[user_business_type-1].sf_name||'' }}</div>

              <el-select
                v-else
                v-model="user_business_type"
                placeholder="请选择类型"
                size="mini"
                class="flex-con"
                popper-class="select_popper"
              >
                <el-option
                  v-for="item in userSF"
                  :key="item.sf_id"
                  :label="item.sf_name"
                  :value="item.sf_id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="font-333-16-bold align-top" style="margin-top: 22px">
              <div class="width102">
                <span class="cor_FA9C22"></span>证明文件:
              </div>
              <input
                type="file"
                accept=".png, .jpg, .jpeg"
                name="file"
                value=""
                id="fileImg"
                @change="uploadData"
                v-show="status == 0 || status == 3"
                class="input1"
              />
              <el-image
                v-show="status == 1 || status == 2"
                style="width: 100px; height: 100px"
                :src="data.user_js_img"
                fit="cover"
              ></el-image>
            </div>
            <div class="font-333-16-bold align-start" style="margin-top: 22px">
              <div class="width102"><span class="cor_FA9C22"></span></div>
              <el-image
                v-show="(status == 0 || status == 3) && data.user_js_img"
                style="width: 100px; height: 100px"
                :src="data.user_js_img"
                fit="cover"
              ></el-image>
            </div>
          </div>
          <div
            class="btn align-center pointer"
            @click="fnTi"
            v-show="status == 0 || status == 3"
          >
            {{ status == 0 ? '提交' : '重新提交' }}
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import MyInfo from '@/components/MyInfo.vue'
import right from '@/components/right.vue'
import {
  commitApply,
  showAuth,
  authStatus,
  uploadFile,
  showUserBaseForH5,
  businessAsk
} from '../api'
export default {
  components: {
    Header,
    Footer,
    MyInfo,
    right,
  },
  data() {
    return {
      status: 0,
      userSFid: 1,
      userSF: [
        {
          sf_id: 1,
          sf_name: '转业军人',
        },
        {
          sf_id: 2,
          sf_name: '退伍仕官',
        },
        {
          sf_id: 3,
          sf_name: '自主择业',
        },
        {
          sf_id: 4,
          sf_name: '军属',
        },{
          sf_id: 5,
          sf_name: '退休',
        },
      ],
      data: {
        user_js_img: '',
        user_business_type: 0,
        user_js_name: '',
        user_business: 1,
      },
      user_business_type: '',
    }
  },
  methods: {
    fnTi() {
      if (!this.data.user_js_name) {
        this.$message.error('请输入姓名')
        return
      }
      if (!this.user_business_type) {
        this.$message.error('请选择身份类型')
        return
      }
      // if (!this.data.user_js_img) {
      //   this.$message.error('请上传证明文件')
      //   return
      // }
      let params = {
        user_js_name: this.data.user_js_name,
        user_business_type: this.user_business_type,
        user_js_img: this.data.user_js_img||'',
      }

      businessAsk(params).then((data) => {
        if (data.status == 200) {
          this.$message.success('提交成功')
          this.initData()
        }
      })
    },
    initData() {
      let params = {}
      showUserBaseForH5(params).then((data) => {
        if (data.status == 200) {
          this.data = data.msg
          this.status = data.msg.user_business_status
          this.user_business_type = data.msg.user_business_type || ''
        }
      })
    },
    uploadData(e) {
      let formData = new FormData()
      let files = e.target.files[0]
      formData.append('file', files)
      console.log(files)
      console.log(formData)
      let _self = this
      return new Promise((resolve, reject) => {
        uploadFile(formData)
          .then((response) => {
            _self.data.user_js_img = response.msg
            // console.log('133||'+response.msg);
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
  mounted() {
    document.title = '爱优服'
    this.initData()
  },
}
</script>

<style scoped>
.input1::file-selector-button {
  width: 101px;
  height: 29px;
  background: #ffffff;
  border: 1px solid #d8d8d8;
  /* border-radius: 5px; */
  font-size: 16px;
  font-weight: 400;
  color: #999;
  padding-bottom: 3px;
  margin-right: 18px;
  cursor: pointer;
}
.input1 {
  font-size: 16px;
  font-weight: 400;
  color: #6eaaf9;
}
.my_order {
  background: #ffffff;
  border-radius: 4px;
  padding: 20px 26px;
  font-size: 14px;
  margin-bottom: 10px;
  text-align: center;
}
.order_box {
  background: #ffffff;
  box-sizing: border-box;
  text-align: left;
  border: 1px solid #eeeeee;
}
input[type='text'] {
  background: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  height: 32px;
  /* width: 250px; */
  padding: 0 12px;
  color: #333333;
  font-size: 16px;
  outline: none;
}
input[type='text']::-webkit-input-placeholder {
  color: #999;
}
input[type='text']:active {
  box-sizing: border-box;
  border: 1px solid #d8d8d8;
}

.btn {
  font-size: 20px;
  color: #ffffff;
  margin: 30px auto 35px;
  width: 256px;
  height: 46px;
  background: #fa9c22;
  border-radius: 4px;
}
.width102 {
  min-width: 102px;
  text-align: right;
  margin-right: 26px;
}
::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

::v-deep .el-input--mini .el-input__inner {
  border-radius: 0px;
  border: 1px solid #d8d8d8;
  height: 32px;
  font-size: 16px;
  /* color: #999; */
}

.el-select-dropdown__item {
  font-size: 16px;
}
.el-select-dropdown__item.selected {
  color: #333;
}

</style>
